<template>
  <el-row class="flex-row page-device-manage">

    <CompSideTree
      pageName="deviceManage"
      ref="treeRef"
      :treeOption="treeOption"
      :treeData="treeData"
      :searchPlaceholder="Lang.Text.deviceSearchSn"
      :bottomAddText="Lang.Button.deviceAddGwGroup"
      :showBottomAdd="true"
      :showDotted="true"
      :permissionObj="permissionObj"
      @update:treeOption="(val) => (treeOption = val)"
      @nodeClick="nodeClick"
      @add="handleSideTreeAdd"
      @edit="handleEditGateway"
      @delete="handleDeleteGateway"
      @move="handleClickMoveNode"
      @bottomAdd="handleAddGatewayGroup"
      @updateSideTree="updateSideTree"
    />

    <el-col class="flex-col limitmain">
      <breadcrumb :repeat="true" v-if="website.setting.breadcrumb" />
      <!-- 网关分组 页面-->
      <basic-card class="new-basic-card-gateway" v-if="currentNode.gatewayType==1">
        <div class="page-pannel">
          <div class="pannel-header">
            <div class="pannel-title">
              {{ currentNode.name }}
            </div>
            <div class="pannel-buttons">
              <comp-button size="medium" v-if="permissionObj.delete" @click="handleDeleteGatewayGroup()" >{{ Lang.btn.delete }}</comp-button>
              <!-- <comp-button size="medium" @click="confirmGatewayGroupStatus(1)" v-if="currentNodeStatus==0">{{ Lang.btn.enable }}</comp-button>
              <comp-button size="medium" @click="confirmGatewayGroupStatus(0)" v-if="currentNodeStatus==1">{{ Lang.btn.disable }}</comp-button> -->
              <comp-button size="medium" v-if="permissionObj.edit" type="primary" @click="handleEditGatewayGroup()" >{{ Lang.btn.edit }}</comp-button>
            </div>
          </div>
          <div class="pannel-detail">
            <div class="info-section">
              <div class="info-title">
                <div class="text">{{ Lang.Title.deviceBasicInfo }}</div>
                <!-- <OnlineStatus :commStatus="gatewayGroupPageDetail.commStatus"></OnlineStatus> -->

              </div>
              <div class="info-content">
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceGwGroupName }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.name || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceSn }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.sn || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceAssetId }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.assetId || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceModel }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.modelName || '—'  }}</div>
                </div>
                <!-- <div class="info-item">
                  <div class="label">{{ 'Manufacturer' }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.manufacturer || '—' }}</div>
                </div> -->
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceOrg }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.deptName || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceInstallLo }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.address || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceDesc }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.des || '—'  }}</div>
                </div>
                <div class="info-item"></div>
              </div>
            </div>
            <div class="info-section">
              <div class="info-title">
                <div class="text">{{ Lang.Title.deviceCommuSet }}</div>
              </div>
              <div class="info-content">
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceCommuAdd }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.location || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.devicePort }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.port || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceAccount }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.account || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.devicePassword }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.password ? '******' : '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceOtherParam }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.paramete1 || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceCommuTineout }}</div>
                  <div class="value">{{ gatewayGroupPageDetail.timeOut || '—' }}</div>
                </div>
                <div class="info-item">
                </div>
                <div class="info-item">
                </div>
              </div>
            </div>
          </div>
        </div>
      </basic-card>
      <!-- 网关 页面-->
      <basic-card class="new-basic-card-gateway" v-if="currentNode.gatewayType==2">
        <div class="page-pannel">
          <div class="pannel-header">
            <div class="pannel-title">
              {{ currentNode.name }}
            </div>
            <div class="pannel-buttons">
              <comp-button size="medium" v-if="permissionObj.delete" @click="handleDeleteGateway()">{{ Lang.btn.delete }}</comp-button>
              <comp-button size="medium" v-if="permissionObj.enable && currentNodeStatus==1" @click="confirmGatewayStatus(0)">{{ Lang.btn.enable }}</comp-button>
              <comp-button size="medium" v-if="permissionObj.disable && currentNodeStatus==0" @click="confirmGatewayStatus(1)">{{ Lang.btn.disable }}</comp-button>
              <comp-button size="medium" v-if="permissionObj.edit" type="primary" @click="handleEditGateway()" >{{ Lang.btn.edit }}</comp-button>
            </div>
          </div>

          <div class="pannel-detail">
            <div class="info-section">
              <div class="info-title">
                <div class="text">{{ Lang.Title.deviceBasicInfo }}</div>
                <OnlineStatus :commStatus="gatewayPageDetail.commStatus"></OnlineStatus>
              </div>
              <div class="info-content">
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceGwName }}</div>
                  <div class="value">{{ gatewayPageDetail.name || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceSn }}</div>
                  <div class="value">{{ gatewayPageDetail.sn || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceGwId }}</div>
                  <div class="value">{{ gatewayPageDetail.id || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceAssetId }}</div>
                  <div class="value">{{ gatewayPageDetail.assetId || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceModel }}</div>
                  <div class="value">{{ gatewayPageDetail.modelName || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceManufac }}</div>
                  <div class="value">{{ gatewayPageDetail.manuFacturer || '—' }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceOrg }}</div>
                  <div class="value">{{ gatewayPageDetail.deptName || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceInstallLo }}</div>
                  <div class="value">{{ gatewayPageDetail.address || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceDesc }}</div>
                  <div class="value">{{ gatewayPageDetail.des || '—'  }}</div>
                </div>
              </div>
            </div>
            <div class="info-section">
              <div class="info-title">
                <div class="text">{{ Lang.Title.deviceCommuSet }}</div>
              </div>
              <div class="info-content">
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceCommuAdd }}</div>
                  <div class="value">{{ gatewayPageDetail.location || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.devicePort }}</div>
                  <div class="value">{{ gatewayPageDetail.port || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceAccount }}</div>
                  <div class="value">{{ gatewayPageDetail.account || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.devicePassword }}</div>
                  <div class="value">{{ gatewayPageDetail.password ? '******' : '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceOtherParam }}</div>
                  <div class="value">{{ gatewayPageDetail.paramete1 || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceCommuTineout }}</div>
                  <div class="value">{{ gatewayPageDetail.timeOut || '—' }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceCommuProtocal }}</div>
                  <div class="value">{{ gatewayPageDetail.protocolName || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceLastCommuTime }}</div>
                  <div class="value">{{ gatewayPageDetail.lastCommunicationTime || '—'  }}</div>
                </div>
                <div class="info-item"></div>
              </div>
            </div>
          </div>
        </div>
      </basic-card>

      <!-- 设备 页面-->
      <basic-card class="new-basic-card-gateway" v-if="currentNode.gatewayType==3">
        <div class="page-pannel">
          <div class="pannel-header">
            <div class="pannel-title">
              {{ currentNode.name }}
            </div>
            <div class="pannel-buttons">
              <comp-button size="medium" v-if="permissionObj.delete" @click="handleDeleteDevice()" >{{ Lang.btn.delete }}</comp-button>
              <!-- deviceStatus 网关状态 0 启用中， 1禁用 网关禁用了设备启用禁用无需展示-->
              <comp-button size="medium" v-if="permissionObj.enable && currentNodeStatus==1 && !deviceForm.deviceStatus" @click="confirmDeviceStatus(0)">{{ Lang.btn.enable }}</comp-button>
              <comp-button size="medium" v-if="permissionObj.disable && currentNodeStatus==0 && !deviceForm.deviceStatus" @click="confirmDeviceStatus(1)">{{ Lang.btn.disable }}</comp-button>
              <comp-button size="medium" v-if="permissionObj.edit" type="primary" @click="handleEditDevice()" >{{ Lang.btn.edit }}</comp-button>
            </div>
          </div>
          
          <div class="pannel-detail">
            <div class="info-section">
              <div class="info-title">
                <div class="text">{{ Lang.Title.deviceBasicInfo }}</div>
                <OnlineStatus :commStatus="devicePageDetail.commStatus"></OnlineStatus>
              </div>
              <div class="info-content">
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceDeviceName }}</div>
                  <div class="value">{{ devicePageDetail.name || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceSn }}</div>
                  <div class="value">{{ devicePageDetail.sn || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceId }}</div>
                  <div class="value">{{ devicePageDetail.rtu || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceAssetId }}</div>
                  <div class="value">{{ devicePageDetail.assetId || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceType }}</div>
                  <div class="value">{{ devicePageDetail.iotProductName || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceModel }}</div>
                  <div class="value">{{ devicePageDetail.modelName || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceManufac }}</div>
                  <div class="value">{{ devicePageDetail.manufacturer || '—' }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceOrg }}</div>
                  <div class="value">{{ devicePageDetail.deptName || '—'  }}</div>
                </div>
                <!-- <div class="info-item">
                  <div class="label">{{ 'Collection Frequency (min)' }}</div>
                  <div class="value">{{ devicePageDetail.frequency || '—'  }}</div>
                </div> -->
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceCommuTimeout }}</div>
                  <div class="value">{{ devicePageDetail.timeOut || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceOpDate }}</div>
                  <div class="value">{{ devicePageDetail.operationalDate || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceInstallLo }}</div>
                  <div class="value">{{ devicePageDetail.address || '—'  }}</div>
                </div>
                <div class="info-item">
                  <div class="label">{{ Lang.Title.deviceDesc }}</div>
                  <div class="value">{{ devicePageDetail.des || '—'  }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="pannel-detail">
            <div class="info-section">
              <div class="info-title">
                <div class="text">{{ Lang.Title.devicePoint }}</div>
                <div class="title-right">
                  <comp-svg name="point-green" class="point-green"></comp-svg>
                  <span class="update-time">
                    {{Lang.Text.deviceUpdateTime}} ：{{ lastUpdateTime }}
                  </span>
                  <span class="refresh">
                    <comp-svg cursor="pointer" :class="{refreshIng: refreshIng}" name="refresh" @click="handleRefresh"></comp-svg>
                  </span>
                </div>
              </div>
              <div class="table-search">
                <div class="search-left">
                  <div class="search-item">
                    <div class="label">{{ Lang.Title.devicePoint }}</div>
                    <div class="value">
                      <el-input v-model="search.name" :placeholder="Lang.tips.plzInput+ ' '+Lang.Title.devicePoint" clearable @input="searchDevice()">
                      </el-input>
                    </div>
                    <div class="label">ID</div>
                    <div class="value">
                      <el-input v-model="search.sid" :placeholder="Lang.tips.plzInput+ ' '+'ID'" clearable @input="searchDevice()">
                      </el-input>
                    </div>
                    <div class="value">
                      <el-select v-model="search.stype" clearable width="100%" @change="searchDevice()">
                        <el-option v-for="(item, i) in ctrlTypes" :key="item.dictKey" :value="item.dictKey">
                          {{ item.i18nValue }}
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <!-- 预防UI不过，需要后台改接口 -->
                <!-- <div class="table-search-item" >
                  <el-input 
                    class="search-input" 
                    style="text-indent: 40px;"
                    v-model="search.nameOrIds"
                    clearable
                    @clear="searchReset"
                    @input="() => {
                      this.onLoad(this.page, this.search)
                    }"
                    :placeholder="Lang.Text.modelSearchPointIds">
                  </el-input>
                  <span class="table-icon-search">
                    <comp-svg name="search" size="13px" fill="#616D7C"></comp-svg>
                  </span>
                </div> -->
                
              </div>
              <div class="common-table">
                <CompTable
                  :data="tableData"
                  :columns="tableColumns"
                  :total="page.total"
                  :page="page.currentPage"
                  :page-size="page.pageSize"
                  header-bg-color="#FFFFFF"
                  header-text-color="#192434"
                  :header-max-lines="2"
                  :actionColumnWidth="80"
                  :showOverflowTooltip="true"
                  :actionLabel="Lang.Title.deviceStore"
                  @page-change="handlePageChange"
                  @size-change="handleSizeChange"
                >
                  <!-- 自定义状态列 -->
                  <template #dataSource="{ row }">
                    <div class="edit-dataSource-column">
                      <span class="text">
                        {{ getDataSourceTypeName(row) }}
                      </span>
                      <span class="appand-icon">
                        <comp-svg name="modify" size="16px" style="cursor: pointer;" @click="handleSettingDataSource(row)"></comp-svg>
                      </span>
                    </div>
                  </template>
                  <template #rtuId="{ row }">
                    <span @click="copyToClipboard(row.id)">{{ row.id }}</span>
                  </template>
                  <!-- 操作列 -->
                  <template #actions="{ row, $index }">
                    <el-switch size="small" v-model="tableData[$index].isStorage" @change="() => handleToggleStorage(row)"></el-switch>
                  </template>
                </CompTable>
              </div>
            </div>
          </div>
        </div>
      </basic-card>

    </el-col>

    <!-- 添加、编辑网关分组弹窗 -->
    <el-dialog
      :title="getGroupDialogTitle()"
      class="global-dialog"
      :show-close="false"
      append-to-body
      :close-on-click-modal="false"
      v-model="gatewayGroupDialogBox"
      size="70%"
    >
      <avue-form
        v-if="gatewayGroupDialogBox"
        :option="gatewayGroupFormOption"
        v-model="gatewayGroupForm"
        ref="gatewayGroupFormRef"
        @submit="handleSubmitGatewayGroup"
        >
      </avue-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="large" @click="gatewayGroupDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button size="large" type="primary" @click="this.$refs.gatewayGroupFormRef.submit()">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 添加网关弹窗 -->
    <el-dialog
      :title="getGatewayDialogTitle()"
      class="global-dialog"
      show-close="false"
      :close-on-click-modal="false"
      append-to-body
      v-model="gatewayDialogBox"
      size="70%"
      height="500"
    >
      <avue-form
        v-if="gatewayDialogBox"
        :option="gatewayFormOption"
        v-model="gatewayForm"
        ref="gatewayFormRef"
        >
      </avue-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="gatewayDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button type="primary" @click="handleSubmitGateway(2)">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 添加设备弹窗 -->
    <el-dialog
      :title="getDeviceDialogTitle()"
      class="global-dialog"
      :close-on-click-modal="false"
      append-to-body
      v-model="deviceDialogBox"
      size="70%"
    >
      <avue-form
        v-if="deviceDialogBox"
        :option="deviceFormOption"
        v-model="deviceForm"
        ref="deviceFormRef"
        >
      </avue-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="large" @click="deviceDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button size="large" type="primary" @click="handleSubmitDevice(3)">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 测量点设置 -->
    <el-dialog
      :title="Lang.Title.devicePointSet"
      append-to-body
      :close-on-click-modal="false"
      v-model="measurementPointSettingDialogBox"
      size="70%"
    >
      <el-form v-model="measurementPointSettingForm" >
        <el-form-item :label="Lang.Title.devicePoint">
          {{ measurementPointSettingForm.name }}
        </el-form-item>
        <el-form-item :label="Lang.Title.deviceDataSource" labelPosition="top">
          <el-select v-model="measurementPointSettingForm.dataSourceType">
            <el-option v-for="(item, i) in dataSourceTypes" :key="item.dictKey" :label="item.i18nValue" :value="item.dictKey"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="Lang.Title.deviceFormulaCollect" v-if="measurementPointSettingForm.dataSourceType==2"  labelPosition="top">
          <el-input type="textarea" :placeholder="Lang.Text.deviceEnterFormula" v-model="measurementPointSettingForm.formula">
          </el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="measurementPointSettingDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button type="primary" @click="handleSubmitMeasurementPointSetting()">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 移动网关、设备 -->
    <el-dialog
      :title="Lang.Title.deviceMoveNode"
      append-to-body
      :close-on-click-modal="false"
      v-model="moveToAnOtherNodeBox"
      class="global-dialog"
      size="70%"
    >
      <el-form v-model="currentNodeForm" >
        <template v-if="currentNodeForm.gatewayType == '2'"">
          <el-form-item :label="Lang.Title.deviceGw" labelPosition="top">
            {{ currentNodeForm.name }}
          </el-form-item>
          <el-form-item :label="Lang.Title.deviceSourceGwGroup" labelPosition="top">
            {{ currentNodeParentData.name }}
          </el-form-item>
          <el-form-item :label="Lang.Title.deviceTargetGwGroup" labelPosition="top">
            <TreeSelect
              v-model="currentNodeForm.destinitionId"
              :tree-data="groupTreeData"
              :treeProps="{
                children: 'childTreeList',
                label: 'name',
                value: 'id',
              }"
              node-key="id"
              :placeholder="Lang.tips.plzSelect"
              @change="handleMoveNodeChange"
            />
          </el-form-item>
          <el-form-item>
            {{ Lang.Text.deviceAllDeviceMove }}
          </el-form-item>
        </template>
        <template v-if="currentNodeForm.gatewayType == '3'"">
          <el-form-item :label="Lang.Title.deviceDeviceName"  labelPosition="top">
            {{ currentNodeForm.name }}
          </el-form-item>
          <el-form-item :label="Lang.Title.deviceSourceGw"  labelPosition="top">
            {{ currentNodeGrandParentData?.name +  '>' + currentNodeParentData.name }}
          </el-form-item>
          <el-form-item :label="Lang.Title.deviceTargetGw" labelPosition="top">
            <TreeSelect
              v-model="currentNodeForm.destinitionId"
              :tree-data="gatewayTreeData"
              :treeProps="{
                children: 'childTreeList',
                label: 'name',
                value: 'id',
              }"
              node-key="id"
              :placeholder="Lang.tips.plzSelect"
              @change="handleMoveNodeChange"
            />
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button size="large" @click="moveToAnOtherNodeBox = false">{{ Lang.btn.cancel }}</el-button>
            <el-button size="large" type="primary" @click="handleSubmitMoveNode()">{{ Lang.btn.confirm }}</el-button>
          </span>
        </template>
    </el-dialog>

  </el-row>
</template>

<script>
import {
  getTreeList,
  getPage as getDevicePage,
  getDetail,
  alarmSetting,
  getAlramList,
  update as updateDeviceStorageApi,
} from '@/api/gateway/data';
import {
  add,
  remove,
  updateGatewayStatus,
  updateDeviceStatus,
  getDetail as getGatewayDetailApi,
  update as updateGatewayOrGroupApi,
  itmeRemove as removeDeviceApi,
  saveItem as addDeviceApi,
  updateItem as updateDeviceApi,
  getItemDetail as getDeviceDetailApi,
  moveGatewayNode,
} from '@/api/gateway/device';

import { mapGetters } from 'vuex';
import website from '@/config/website';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import func from '@/utils/func';
import { yesOrNo, alarmLevels, alarmTypes } from '@/const/options';
import { getDictionary } from '@/api/system/dict';
import { defineAsyncComponent } from 'vue';
import { filterDollarKeys, filterByGatewayType, removeParentZeroNodes, copyToClipboard } from '@/utils/util';
import { validateAssetId, validatePass, validateDeviceId, validateGatewayId, validateTimeout } from '@/utils/validator';
import { Lang } from '@/lang/lang';
import CompTable from '@/components/comp-table/index.vue';
import CompSideTree from '@/components/comp-side-tree/index.vue';
import TreeSelect from './comps/TreeSelect.vue';
import OnlineStatus from '@/views/gatewayManage/comps/OnlineStatus.vue';

import { getModelList } from '@/api/gateway/model';





export default {
  components: {
    CompTable,
    compTabs: defineAsyncComponent(() => import('@/components/comp-tab/index.vue')), // 懒加载,
    TreeSelect,
    OnlineStatus,
    CompSideTree,
  },
  data() {
    return {
      form: {},
      ctrlTypes: [],
      search: {
        stype: 'All',
      },
      refreshIng: false,
      moveToAnOtherNodeBox: false,
      dialogBox: false,
      configBox: false,
      itemId: '',
      operationType: '',
      excelBox: false,
      platformBox: false,
      initFlag: true,
      auditMode: false,
      selectionList: [],
      query: {},
      loading: true,
      platformLoading: false,

      dataSourceTypes: [],
      settingForm: {
        dynamicFields: [],
      },
      syncParentData: {}, // 选择的父网关组详细信息
      currentNode: {},
      currentNodeStatus: 0, // 状态

      measurementPointSettingDialogBox: false,
      measurementPointSettingForm: {
        dataSource: '',
        calculationFormula: ''
      },

      showGatewayGroup: true,
      gatewayGroupFormDisabled: true,
      gatewayGroupDialogBox: false,
      gatewayGroupForm: {
        gatewayType: 1, // 1网关分组,2网关
        tenantId: this.userInfo?.tenant_id,
      },
      gatewayGroupPageDetail: {},
      gatewayPageDetail: {},
      devicePageDetail: {},
      gatewayGroupFormOption: {
        gutter: 20,
        emptyBtn: false,
        submitBtn: false,
        labelSuffix: ' ',
        group: [
          // 新增弹出的form及校验
          {
            label: this.Lang.Title.deviceBasicInfo,
            prop: 'gatewayInfo',
            // icon: 'el-icon-user-solid',
            labelPosition: 'top',
            labelTipPlacement: 'top-start',
            labelWidth: '120px',
            column: [
              {
                label: Lang.Title.deviceGwGroupName,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceGwGroupName,
                prop: 'name',
                maxlength: 200,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceGwGroupName,
                    trigger: 'click',
                  },
                ],
                span: 12,
              },
              // {
              //   label: this.Lang.label.enName,
              //   prop: 'enName',
              //   maxlength: 200,
              //   search: true,
              //   align: 'center',
              //   rules: [
              //     {
              //       required: true,
              //       message: this.Lang.tips.inputDictEnName,
              //       trigger: 'blur',
              //     },
              //   ],
              // },
              // {
              //   label: this.Lang.label.localName,
              //   prop: 'localName',
              //   maxlength: 200,
              //   search: true,
              //   align: 'center',
              //   rules: [
              //     {
              //       required: true,
              //       message: this.Lang.tips.inputDictLocalName,
              //       trigger: 'blur',
              //     },
              //   ],
              // },
              {
                label: this.Lang.Title.deviceSn,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceSn,
                prop: 'sn',
                maxlength: 50,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.Title.deviceAssetId,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceAssetId,
                prop: 'assetId',
                maxlength: 30,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [
                  { required: false, trigger: 'blur' },
                  {
                    validator: validateAssetId,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.label.model,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.label.model,
                prop: 'modelId',
                type: 'select',
                dicUrl: '/emp-data-center/emp-data/model/list?iotProduct=gateway_group',
                // dicFormatter: res => {
                //   return res.data.data;
                // },
                dataType: 'string',
                props: {
                  label: 'name',
                  value: 'id',
                },
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzInputUnit,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              // man 提 bug 要求必填
              // https://www.tapd.cn/tapd_fe/60266952/bug/detail/1160266952001003169
              {
                label: this.Lang.Title.deviceOrg,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceOrg,
                prop: 'deptId',
                type: 'tree',
                dicUrl: '/blade-system/dept/tree',
                dicFormatter: res => {
                  const filterData = removeParentZeroNodes(res.data);
                  console.log('处理0级后的组织', filterData)
                  return filterData;
                },
                rules: [{ required: true, message: this.Lang.tips.plzSelect + '  ' + this.Lang.Title.deviceOrg, trigger: 'blur' }],
                nodeKey: 'id',
                props: {
                  label: 'title',
                  value: 'id',
                },
                slot: true,
              },
              {
                label: this.Lang.Title.deviceInstallLo,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceInstallLo,
                prop: 'address',
                maxlength: 200,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              // {
              //   label: this.Lang.Title.deviceManufac,
              //   prop: 'manuFacturer',
              //   maxlength: 200,
              //   hide: false,
              //   editDisplay: true,
              //   viewDisplay: true,
              //   rules: [{ required: false, trigger: 'blur' }],
              //   span: 12,
              // },
              {
                label: this.Lang.Title.deviceDesc,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceDesc,
                prop: 'des',
                type: 'textarea',
                maxlength: 2000,
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzInput,
                    trigger: 'blur',
                  },
                ],
                span: 24,
              },
            ],
          },
          {
            label: this.Lang.Title.deviceCommuSet,
            prop: 'communicationSettings',
            labelPosition: 'top',
            labelTipPlacement: 'top-start',
            column: [
              {
                label: this.Lang.Title.deviceCommuAdd,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceCommuAdd,
                prop: 'location',
                maxlength: 200,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.port,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.label.port,
                prop: 'port',
                dataType: 'number',
                maxlength: 10,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.account,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.label.account,
                prop: 'account',
                maxlength: 100,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.password,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.label.password,
                prop: 'password',
                maxlength: 100,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
              },
              {
                label: this.Lang.Title.deviceOtherParam,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceOtherParam,
                prop: 'paramete1',
                maxlength: 200,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
              },
              {
                label: this.Lang.Title.deviceCommuTimeout,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceCommuTimeout,
                dataType: 'number',
                maxlength: 5,
                slot: true,
                prop: 'timeOut',
                span: 12,
              },
              
            ],
          }
        ],
      },

      gatewayDialogBox: false,
      gatewayForm: {
        tenantId: this.userInfo?.tenant_id,
      },
      gatewayFormOption: {
        emptyBtn: false,
        submitBtn: false,
        gutter: 20,
        labelSuffix: ' ',
        group: [
          // 新增弹出的form及校验
          {
            label: this.Lang.label.gatewayInfo,
            prop: 'gatewayInfo',
            // icon: 'el-icon-user-solid',
            labelPosition: 'top',
            labelTipPlacement: 'top-start',
            labelWidth: '120px',
            column: [
              {
                label: this.Lang.table.gatewayName,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.table.gatewayName,
                prop: 'name',
                maxlength: 200,
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.plzInputGatewayName,
                    trigger: 'click',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.Title.deviceSn,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceSn,
                prop: 'sn',
                maxlength: 50,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.Title.deviceGwId,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceGwId,
                prop: 'id',
                maxlength: 50,
                hide: false,
                editDisplay: false,
                viewDisplay: true,
                addDisplay: true,
                rules: [{ validator: validateGatewayId, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.Title.deviceAssetId,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceAssetId,
                prop: 'assetId',
                maxlength: 30,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [
                  { required: false, trigger: 'blur' },
                  {
                    validator: validateAssetId,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              {
                label: this.Lang.label.model,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.label.model,
                prop: 'modelId',
                type: 'select',
                dicUrl: '/emp-data-center/emp-data/model/list?iotProduct=gateway',
                // dicFormatter: res => {
                //   return res.data.data;
                // },
                dataType: 'string',
                props: {
                  label: 'name',
                  value: 'id',
                },
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzInputUnit,
                    trigger: 'blur',
                  },
                ],
                span: 12,
              },
              // man 提 bug 要求必填
              // https://www.tapd.cn/tapd_fe/60266952/bug/detail/1160266952001003175
              {
                label: this.Lang.Title.deviceOrg,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceOrg,
                prop: 'deptId',
                type: 'tree',
                dicUrl: '/blade-system/dept/tree',
                dicFormatter: res => {
                  const filterData = removeParentZeroNodes(res.data);
                  console.log('处理0级后的组织', filterData)
                  return filterData;
                },
                rules: [{ required: true, message: this.Lang.tips.plzSelect + '  ' + this.Lang.Title.deviceOrg, trigger: 'blur' }],
                nodeKey: 'id',
                props: {
                  label: 'title',
                  value: 'id',
                },
                slot: true,
              },
              // {
              //   label: this.Lang.Title.deviceManufac,
              //   prop: 'manuFacturer',
              //   maxlength: 200,
              //   hide: false,
              //   editDisplay: true,
              //   viewDisplay: true,
              //   rules: [{ required: false, trigger: 'blur' }],
              //   span: 12,
              // },
              {
                label: this.Lang.Title.deviceInstallLo,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceInstallLo,
                prop: 'address',
                maxlength: 200,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.Title.deviceDesc,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceDesc,
                prop: 'des',
                type: 'textarea',
                maxlength: 2000,
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzInput,
                    trigger: 'blur',
                  },
                ],
                span: 24,
              },
            ],
          },
          {
            label: this.Lang.Title.deviceCommuSet,
            prop: 'communicationSettings',
            labelPosition: 'top',
            labelTipPlacement: 'top-start',
            column: [
              {
                label: this.Lang.Text.deviceSyncParent,
                prop: 'inherit',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                lebalPosition: 'left',
                rules: [{ required: false, trigger: 'blur' }],
                span: 24,
                type: 'switch',
                onChange: (item) => {
                  if (item.value) {
                    if (this.parentData.id === this.syncParentData?.id) {
                      this.setComunicationInfo(this.syncParentData);
                      this.disabledForm(this.gatewayFormOption, true)
                      return;
                    }
                    getGatewayDetailApi(this.parentData.id).then(Response => {
                      const res = Response.data;
                      if (res.code === 200) {
                        this.syncParentData = res.data;
                        this.setComunicationInfo(this.syncParentData);
                        this.disabledForm(this.gatewayFormOption, true)
                      } else {
                        this.$message.error(res.msg);
                      }
                    })
                  } else {
                    this.disabledForm(this.gatewayFormOption, false)
                  }
                }
              },
              {
                label: this.Lang.Title.deviceCommuAdd,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceCommuAdd,
                prop: 'location',
                hide: false,
                maxlength: 200,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.port,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.label.port,
                prop: 'port',
                dataType: 'number',
                maxlength: 10,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.account,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.label.account,
                prop: 'account',
                maxlength: 100,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.label.password,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.label.password,
                prop: 'password',
                maxlength: 100,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
              },
              {
                label: this.Lang.Title.deviceOtherParam,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceOtherParam,
                prop: 'paramete1',
                maxlength: 200,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
              },
              {
                label: this.Lang.Title.deviceCommuTineout,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceCommuTineout,
                dataType: 'number',
                maxlength: 5,
                slot: true,
                prop: 'timeOut',
                rules: [{ required: false, validator: validateTimeout, trigger: 'blur' }],
                span: 12,
              },
              
            ],
          }
        ],
      },

      deviceDialogBox: false,
      deviceForm: {
        tenantId: this.userInfo?.tenant_id,
      },
      deviceFormOption: {
        emptyBtn: false,
        submitBtn: false,
        gutter: 20,
        labelSuffix: ' ',
        group: [
          // 新增弹出的form及校验
          {
            label: this.Lang.label.deviceInfo,
            prop: 'deviceInfo',
            // icon: 'el-icon-user-solid',
            labelPosition: 'top',
            labelTipPlacement: 'top-start',
            labelWidth: '120px',
            column: [
              {
                label: this.Lang.Title.deviceDeviceName,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceDeviceName,
                prop: 'name',
                maxlength: 100,
                slot: false, // 自定义内容格式化
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.plzInputDeviceName,
                    trigger: 'click',
                  },
                ],
              },
              {
                maxlength: 30,
                label: this.Lang.Title.deviceSn,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceSn,
                prop: 'sn',
                search: false,
              },
              {
                // label: 'RTU ID',
                label: this.Lang.table.deviceId,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.table.deviceId,
                prop: 'rtu',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
                // dataType: 'number',
                maxlength: 50,
                rules: [{ required: true, validator: validateDeviceId, trigger: 'blur' }],
              },
              {
                label: this.Lang.table.assetId,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.table.assetId,
                prop: 'assetId',
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
                // dataType: 'number',
                maxlength: 50,
                rules: [{ required: false, validator: validateAssetId, trigger: 'blur' }],
              },
              {
                label: this.Lang.Title.deviceType,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceType,
                prop: 'iotProduct',
                type: 'select',
                dicUrl: '/blade-system/dict/dictionary?code=iotProduct',
                dicFormatter: res => {
                  return res.data.filter(item => !['1','2'].includes(item.dictKey));
                },
                onChange: (col) => {
                  this.updateModelIdOptions(col.value)
                },
                rules: [
                  {
                    required: true,
                    message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceType,
                    trigger: 'blur',
                  },
                ],
                props: {
                  label: 'i18nValue',
                  value: 'dictKey',
                },
                slot: true,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
              },
              {
                label: this.Lang.Title.deviceModel,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceModel,
                prop: 'modelId',
                type: 'select',
                dicData: [],
                slot: true,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                span: 12,
                rules: [{ required: true, message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceModel, trigger: 'blur' }],
              },
              {
                label: this.Lang.Title.deviceOrg,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceOrg,
                prop: 'deptId',
                type: 'tree',
                dicUrl: '/blade-system/dept/tree',
                dicFormatter: res => {
                  const filterData = removeParentZeroNodes(res.data);
                  console.log('处理0级后的组织', filterData)
                  return filterData;
                },
                nodeKey: 'id',
                props: {
                  label: 'title',
                  value: 'id',
                },
                rules: [{ required: true, message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceOrg, trigger: 'blur' }],
                slot: true,
              },
              {
                label: this.Lang.Title.deviceCommuTimeout,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceCommuTimeout,
                dataType: 'number',
                maxlength: 5,
                slot: true,
                prop: 'timeOut',
                rules: [{ required: false, validator: validateTimeout, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.Title.deviceDeviceAlarm,
                type: 'switch',
                maxlength: 5,
                slot: true,
                prop: 'alarmOff',
                dataType: 'Boolean',
                span: 12,
              },
              {
                label: this.Lang.Title.deviceOpDate,
                placeholder: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.deviceOpDate,
                prop: 'operationalDate',
                search: false,
                addDisplay: true,
                editDisplay: true,
                span: 12,
                type: 'date',
                format: 'YYYY-MM-DD',
                valueFormat: 'YYYY-MM-DD',
              },
              {
                label: this.Lang.Title.deviceInstallLo,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceInstallLo,
                prop: 'address',
                maxlength: 200,
                hide: false,
                editDisplay: true,
                viewDisplay: true,
                rules: [{ required: false, trigger: 'blur' }],
                span: 12,
              },
              {
                label: this.Lang.Title.deviceDesc,
                placeholder: this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceDesc,
                prop: 'des',
                type: 'textarea',
                maxlength: 200,
                rules: [
                  {
                    required: false,
                    message: this.Lang.tips.plzInput,
                    trigger: 'blur',
                  },
                ],
                span: 24,
              },

            ],
          },
        ],
      },

      moveToAnOtherNodeBox: false,
      currentNodeForm: {},
      currentNodeParentData: {},
      lastUpdateTime: '',

      settingOption: {
        gutter: 12,
      },
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      platformPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      init: {
        roleTree: [],
        deptTree: [],
      },
      props: {
        label: 'title',
        value: 'key',
      },
      roleGrantList: [],
      roleTreeObj: [],
      treeDeptId: '',
      treeData: [],
      groupTreeData: [], // 移动网关选分组
      gatewayTreeData: [], // 移动设备选网关
      treeOption: {
        nodeKey: 'id',
        lazy: false,
        defaultExpandAll: false,
        filterText: this.Lang.tips.plzInputFilterText,
        addBtn: false,
        // menu: false,
        editBtn: false,
        delBtn: false,
        filter: false,
        expandLevel: 0,
        size: 'small',
        props: {
          labelText: this.Lang.tips.title,
          label: 'name',
          value: 'code',
          children: 'childTreeList',
        },
        // treeLoad: function (node, resolve) {
        //   const parentId = node.rank === 1 ? '00' : node.data.parentId;
        //   const params = {
        //     parentId,
        //   };
        //   getTreeList(params).then(res => {
        //     resolve(
        //       res.data.data.map(item => {
        //         return {
        //           ...item,
        //           leaf: !item.childTreeList.length,
        //         };
        //       })
        //     );
        //   });
        // },
      },
      tableData: [],
      tableColumns: [
        {
          label: 'ID',
          prop: 'sid',
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          label: this.Lang.Text.deviceDataId,
          prop: 'id',
          slotName: 'rtuId',
          width: 80,
          align: 'center',
          fixed: 'left',
        },
        {
          label: this.Lang.Title.deviceType,
          prop: 'stype',
          width: 80,
          align: 'center',
        },
        {
          label: this.Lang.Title.devicePoint,
          prop: 'name',
          width: 150,
          align: 'center',
        },
        {
          label: this.Lang.Title.deviceFormat,
          prop: 'datatypeName',
          width: 100,
          align: 'center',
        },

        {
          label: this.Lang.Title.deviceMeasValue,
          prop: 'val',
          // width: 150,
          align: 'center',
          // slotName: 'val',
          // headerBgColor: '#f0f9eb',
          // headerTextColor: '#67c23a'
        },
        {
          label: this.Lang.Title.deviceUnit,
          prop: 'unit',
          width: 80,
          align: 'center',
        },


        {
          label: this.Lang.Title.deviceMeasTime,
          prop: 'valLastUpdateTime',
          // width: 150,
          align: 'center',
        },
        {
          label: this.Lang.Title.deviceDataSource,
          prop: 'calcrule',
          slotName: 'dataSource',
          width: 200,
          align: 'center',
        },
        {
          label: this.Lang.Title.deviceEnumDef,
          prop: 'itemEnum',
          width: 150,
          align: 'center',
        },
      ],
    };
  },
  watch: {
    // 'deviceForm.iotProduct'(newVal) {
    //   if (newVal) {
    //     this.updateModelIdOptions(newVal);
    //   }
    // },
  },
  computed: {
    ...mapGetters(['menuItem', 'permission', 'userInfo']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  mounted() {
    this.initData(this.userInfo.tenant_id);
  },
  created() {},
  methods: {
    copyToClipboard(value) {
      copyToClipboard(value);
      this.$message({
        type: 'success',
        message: this.Lang.tips.hasBeenCopiedToClipboard,
      });
    },
    updateModelIdOptions(iotProduct) {
      getModelList({iotProduct}).then((res) => {
        if (res.status === 200) {
          const options = res.data.data.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          this.deviceFormOption.group[0].column.forEach((column) => {
            if (column.prop === 'modelId') {
              column.dicData = options; // 更新 modelId 的选项数据
            }
          });
        } else {
          console.error('Failed to fetch modelId options:', res.message);
        }
      });
    },
    getFourRemoteTypes() {
      getDictionary({code: 'typesOfTelemetering'}).then(res => {
        const data = res.data.data;
        data.unshift({
          dictKey: 'All',
          // i18nValue: Lang.Text.modelAll,
          i18nValue: 'All',
        })
        this.search.stype = 'All';
        this.ctrlTypes = data;
      })
    },
    getGroupDialogTitle() {
      if (this.operationType == 'add') {
        return Lang.Button.deviceAddGwGroup;
      } if (this.operationType == 'edit'){
        return Lang.Title.deviceEditGwGroup;
      }
    },
    getGatewayDialogTitle() {
      if (this.operationType == 'add') {
        return Lang.Button.deviceAddGw;
      } if (this.operationType == 'edit'){
        return Lang.Title.deviceEditGw;
      }
    },
    getDeviceDialogTitle() {
      if (this.operationType == 'add') {
        return Lang.Button.deviceAddDevice;
      } if (this.operationType == 'edit'){
        return Lang.Button.deviceEdit;
      }
    },
    // 自定义查看
    handleView(row) {
      this.$refs.crud.rowView(row);
    },
    // 自定义编辑
    handleEdit(row) {
      this.$refs.crud.rowEdit(row);
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    formAddRow(row) {
      // 添加一个新的行
      this.settingForm.dynamicFields.push({ key: '', value: '' });
    },
    formRemoveRow(index) {
      // 删除指定的行
      this.settingForm.dynamicFields.splice(index, 1);
    },
    handleSetting(row) {
      this.itemId = row.id;
      this.configBox = true;
      getAlramList(row.id).then(res => {
        let alarmList = [];
        if (res.status === 200) {
          alarmList = res.data.data;
        } else {
          alarmList = [{}];
        }
        this.$nextTick(() => {
          this.$refs.AlarmConfigModel.updateAlarmList(alarmList);
        });
      });
    },
    handleCancel() {
      this.configBox = false;
    },
    // 测点配置编辑
    handleSettingDataSource(row) {
      this.measurementPointSettingForm = {};
      this.measurementPointSettingForm = row;
      this.measurementPointSettingDialogBox = true;
    },
    getDataSourceTypeName(row) {
      const item = this.dataSourceTypes.find(item => item.dictKey == row.dataSourceType) || {}
      return item.i18nValue || '';
    },
    // 测量点配置Data Source
    handleSubmitMeasurementPointSetting() {
      const row = this.measurementPointSettingForm;
      // if (row.dataSourceType == 2 && (!row.formula || !row.formula.trim())) {
      //   this.$message.warning(this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceFormulaCollect);
      //   return;
      // }
        if (row.dataSourceType == 2) {
        if (!row.formula || !row.formula.trim()) {
          this.$message.warning(this.Lang.tips.plzInput + ' ' + this.Lang.Title.deviceFormulaCollect);
          return;
        }

        // 正则表达式校验 formula 格式
        const formulaRegex = /^\[([a-zA-Z0-9_=]+)\](?:[\+\-\*/%√\^]\[([a-zA-Z0-9_=]+)\])*(?:(\+|\-|\*|\/|\^|\s*)\d+)?$/;
        if (!formulaRegex.test(row.formula.trim())) {
          this.$message.error(this.Lang.Text.basicTxPlsEnCorrect.replace('{Title}', this.Lang.Title.deviceFormulaCollect));
          return;
        }
      }
      if (row.dataSourceType == 1) {
        row.formula = '';
      }
      if (this.loading) {
        console.log('加载中...')
        return
      }
      this.loading = true;
      updateDeviceStorageApi(row).then(
        () => {
          this.loading = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.measurementPointSettingDialogBox = false;

        },
        error => {
          this.loading = false;
          window.console.log(error);
        }
      );
    },
    // 切换是否存储
    confirmToggleStorage(row) {
      return new Promise((resolve, reject) => {
        this.$dialog({
          title: this.Lang.label.tips,
          content: this.Lang.table.ifSave,
          confirmButtonText: this.Lang.btn.confirm,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        })
          .then(() => {
            const param = {
              store: row.isStorage ? 0 : 1,
              id: row.id,
              rtuId: row.rtuId,
              sid: row.sid,
              deviceId: row.deviceId,
              tenantId: row.tenantId,
            }
            return updateDeviceStorageApi(param);
          })
          .then( () => {
            this.onLoad(this.page);
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
            resolve(true)
          },
          error => {
            window.console.log(error);
            reject(false)
          }
        )
      })
    },
    // 是否存储
    handleToggleStorage(row) {
      row.isStorage ? row.store = 1 : row.store = 0;
      updateDeviceStorageApi(row).then(
        () => {
          // this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        },
        error => {
          window.console.log(error);
        }
      );
    },
    // 报警配置提交
    handleSubmit(form, done, loading) {
      const list = form.dynamic;
      const params = [];
      const itemId = this.itemId;
      list.map(item => {
        params.push({
          id: item.id,
          tenantId: item.tenantId,
          itemId: itemId,
          alarmType: item.alarmType,
          alarmLevel: item.alarmLevel,
          alarmVal: item.alarmVal,
        });
      });
      alarmSetting(itemId, params).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.configSucceed,
          });
          done();
          this.configBox = false;
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    // 同步父级网关分组的通信参数
    setComunicationInfo(parentData) {
      this.gatewayFormOption.group[1].column.forEach(item => {
        if (item.prop === 'location') {
          this.gatewayForm.location = parentData.location;
        }
        if (item.prop === 'port') {
          this.gatewayForm.port = parentData.port;
        }
        if (item.prop === 'account') {
          this.gatewayForm.account = parentData.account;
        }
        if (item.prop === 'password') {
          this.gatewayForm.password = parentData.password;
        }
        if (item.prop === 'paramete1') {
          this.gatewayForm.paramete1 = parentData.paramete1;
        }
        if (item.prop === 'timeOut') {
          this.gatewayForm.timeOut = parentData.timeOut;
        }
      })
    },
    // 添加网关分组
    handleAddGatewayGroup() {
      this.gatewayGroupForm = {
        gatewayType: 1, // 1网关分组,2网关
        tenantId: this.userInfo?.tenant_id,
      };
      this.gatewayGroupFormDisabled = false;
      this.operationType = 'add';
      this.gatewayGroupDialogBox = true;
    },
    // 添加、编辑网关分组提交
    handleSubmitGatewayGroup(form, done) {
      const params = filterDollarKeys(this.gatewayGroupForm);
      const submitGroupFn = this.operationType === 'edit' ? updateGatewayOrGroupApi : add;
      submitGroupFn(params).then(
        () => {
          this.updateSideTree()
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.gatewayGroupDialogBox = false;
          done()
        },
        error => {
          done()
          window.console.log(error);
        }
      );
    },
    // 查看【网关分组、网关】详细
    getGatewayOrGroupDetail(id) {
      getGatewayDetailApi(id).then(res => {
        const data = res.data.data;
        this.currentNodeStatus = data.status;
        if (data.gatewayType == 1) {
          this.gatewayGroupPageDetail = {
            ...data,
          };
          this.gatewayGroupForm = {
            ...data,
          }
        } else {
          this.gatewayPageDetail = {
            ...data,
          };
          this.gatewayForm = {
            ...data,
          };
        }
      });
    },
    
    
    // 切换当前页面到可编辑状态 因为点新增后会清空，所以必须查一次..
    handleEditGatewayGroup() {
      this.operationType = 'edit';
      getGatewayDetailApi(this.currentNode.id).then(res => {
        const data = res.data.data;
        this.currentNodeStatus = data.status;
        if (data.gatewayType == 1) {
          this.gatewayGroupPageDetail = {
            ...data,
          };
          this.gatewayGroupForm = {
            ...data,
          }
        }
        this.gatewayGroupDialogBox = true;
      });
      
    },
    // 添加网关 提交
    handleSubmitGateway() {
      const params = filterDollarKeys(this.gatewayForm);
      const submitGroupFn = this.operationType === 'edit' ? updateGatewayOrGroupApi : add;
      this.$refs.gatewayFormRef.validate((flag) => {
        if (!flag) {
          return;
        }
        submitGroupFn(params).then(
          () => {
            this.updateSideTree()
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
            this.gatewayDialogBox = false;
          },
          error => {
            window.console.log(error);
          }
        );
      })
    },
    disabledGatewayId(flag) {
      this.gatewayFormOption.group[0].column.forEach(col => {
        if (col.prop === 'id') {
          col.disabled = flag;
        }
      })
    },
    // 查看时禁用编辑
    disabledForm(option, flag) {
      if (option.group) {
        option.group.forEach(section => {
          if (section.column && section.column.length) {
            section.column.forEach(col => {
              if (['location', 'port', 'account', 'password', 'paramete1', 'timeOut'].includes(col.prop)) {
                col.disabled = flag;
              }
            })
          }
        })
      } else {
        if (option.column && option.column.length) {            
          option.column.forEach(col => {
            if (['location', 'port', 'account', 'password', 'paramete1', 'timeOut'].includes(col.prop)) {
              col.disabled = flag;
            }
          });
        }
      }
      option.formKey++
    },
    // 树右键添加 网关、设备
    handleSideTreeAdd(node) {
      const data = node.data; // 从树的网关分组添加网关 或 从网关添加设备
      this.parentData = data; // 保存用于查同步{{ Lang.Title.deviceCommuSet }}
      this.operationType = 'add';
      if (data.gatewayType == 1) { // 从网关分组点击
        this.gatewayForm = {
          inherit: false,
          parentId: data.id,
          gatewayType: 2, // 1网关分组,2网关,3设备
          tenantId: this.userInfo?.tenant_id,
          status: 0,
        };
        this.disabledForm(this.gatewayFormOption, true)
        this.disabledGatewayId(false);
        this.gatewayDialogBox = true;
      } else if (data.gatewayType == 2) { // 从网关点击
        // 添加设备
        this.deviceForm = {
          deviceId: data.id,
          alarmOff: true,
          status: 0,
          gatewayType: 3, // 1网关分组,2网关,3设备
          tenantId: this.userInfo?.tenant_id,
        };
        this.deviceDialogBox = true;
      }
    },
    // 选择
    handleMoveNodeChange(nodeId, node) {
      const data = node.data;
      if (this.currentNodeParentData.gatewayType == 1) { // 移动网关
        if (data.gatewayType != 1) {
          this.$message.error(this.Lang.tips.plzSelect + this.Lang.Title.deviceTargetGwGroup)
          this.currentNodeForm.destinitionId = '';
        }
      }
      if (this.currentNodeParentData.gatewayType == 2) { // 移动设备
        if (data.gatewayType != 2) {
          this.$message.error(this.Lang.tips.plzSelect + this.Lang.Title.deviceTargetGw)
          this.currentNodeForm.destinitionId = '';
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return this.currentNodeForm.gatewayType == data.gatewayType;
      // return data.label.includes(value)
    },
    setDisabledByGatewayTypeImmutable(treeData, childrenKey = 'children', gatewayType) {
      if (!Array.isArray(treeData)) return [];
      return treeData.map(item => {
        const newItem = {...item};
        // 如果gatewayType存在且不等于2，则禁用该节点
        if ('gatewayType' in newItem && newItem.gatewayType != gatewayType) {
          newItem.disabled = true;
        }
        // 递归处理子节点
        if (newItem[childrenKey] && newItem[childrenKey].length > 0) {
          newItem[childrenKey] = this.setDisabledByGatewayTypeImmutable(newItem[childrenKey], childrenKey, gatewayType);
        }
        return newItem;
      });
    },
    // 树右键移动网关、设备
    handleClickMoveNode(node) {
      this.currentNodeForm = {}
      this.currentNodeForm = {
        ...node.data
      }
      this.currentNodeParentData = node.parent?.data || {};
      this.currentNodeGrandParentData = node.parent?.parent?.data || {}
      if (node.data.gatewayType == 2) { // 网关
        const parentNodes = filterByGatewayType(this.treeData, [1])
        this.groupTreeData = parentNodes
        
      } else if (node.data.gatewayType == 3) { // 设备
        const parentNodes = filterByGatewayType(this.treeData, [2])
        this.gatewayTreeData = parentNodes
      }
      this.moveToAnOtherNodeBox = true;
    },
    // 树右键移动网关、设备
    handleSubmitMoveNode() {
      const params = {
        id: this.currentNodeForm.id,
        parentId: this.currentNodeForm.destinitionId
      };
      if (!params.parentId) {
        return
      }
      moveGatewayNode(params)
      .then(() => {
        this.$message({
          type: 'success',
          message: this.Lang.tips.operationSuccess,
        });
        this.parentData = {}; // 清空父级网关分组数据
        this.syncParentData = {}; // 清空同步父级网关分组数据
        this.moveToAnOtherNodeBox = false;
        this.updateSideTree()
        });
    },
    // 查看网关
    handleViewGateway(node) {
      // this.operationType = 'view';
      // const data = node.data;
      // getGatewayDetailApi({id: data.id}).then(res => {
      //   const data = res.data.data;
      //   this.gatewayForm = {
      //     ...data,
      //   };
      //   this.dialogBox = true;
      // });
    },
    // 编辑网关
    handleEditGateway() {
      this.operationType = 'edit';
      getGatewayDetailApi(this.currentNode.id).then(res => {
        const data = res.data.data;
        this.currentNodeStatus = data.status;
        if (this.currentNode.gatewayType === 1) {
          this.gatewayGroupForm = {
            ...data,
          };
          this.gatewayGroupDialogBox = true;
        } else {
          this.disabledForm(this.gatewayFormOption, true)
          this.gatewayForm = {
            ...data,
          };
          this.gatewayDialogBox = true;
        }
        this.disabledGatewayId(true);
      });
    },
    // 删除网关分组
    handleDeleteGatewayGroup() {
      this.$dialog({
        title: this.Lang.Title.deviceDelGwGroup,
        content: this.Lang.Text.deviceDelGwGroupCon,
        confirmButtonText: this.Lang.Button.deviceDelete,
        cancelButtonText: this.Lang.btn.cancel,
        showClose: false,
      })
        .then(() => {
          return remove(this.currentNode.id);
        })
        .then(() => {
          this.updateSideTree('delete')
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    // 删除网关
    handleDeleteGateway() {
      const data = this.currentNode;
      this.$dialog({
        title: this.Lang.Title.deviceDelGw,
        content: this.Lang.Text.deviceDelGwCon,
        confirmButtonText: this.Lang.Button.deviceDelete,
        cancelButtonText: this.Lang.btn.cancel,
        showClose: false,
      })
        .then(() => {
          return remove(data.id);
        })
        .then(() => {
          this.updateSideTree('delete')
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    
    // 删除设备
    handleDeleteDevice() {
      this.$dialog({
        title: this.Lang.Title.deviceDelDevice,
        content: this.Lang.Text.deviceDelDeviceCon,
        confirmButtonText: this.Lang.Button.deviceDelete,
        cancelButtonText: this.Lang.btn.cancel,
        showClose: false,
      })
        .then((res) => {
          return removeDeviceApi(this.currentNode.id);
        })
        .then(() => {
          this.updateSideTree('delete')
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },

    // 确认网关分组状态
    confirmGatewayGroupStatus(flag) {
      if (!flag) {
        this.$dialog({
          title: this.Lang.Title.deviceEnGwGroup,
          content: this.Lang.Text.deviceEnGwGroupCon,
          confirmButtonText: this.Lang.btn.enable,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        }).then(res => {
          this.changeGatewayOrGroupStatus(flag);
        })
      } else {
        this.$dialog({
          title: this.Lang.Title.deviceDisGwGroup,
          content: this.Lang.Text.deviceDisGwGroupCon,
          confirmButtonText: Lang.btn.disable,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        }).then(res => {
          this.changeGatewayOrGroupStatus(flag);
        })
      }
    },

    // 确认网关状态
    confirmGatewayStatus(flag) {
      if (!flag) {
        this.$dialog({
          title: this.Lang.Title.deviceEnGw,
          content: this.Lang.Text.deviceEnGwCon,
          confirmButtonText: this.Lang.btn.enable,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        }).then(res => {
          this.changeGatewayOrGroupStatus(flag);
        })
      } else {
        this.$dialog({
          title: this.Lang.Title.deviceDisGw,
          content: this.Lang.Text.deviceDisGwCon,
          confirmButtonText: this.Lang.Button.deviceDisable,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        }).then(res => {
          this.changeGatewayOrGroupStatus(flag);
        })
      }
    },

    // 确认设备状态
    confirmDeviceStatus(flag) {
      if (!flag) {
        this.$dialog({
          title: this.Lang.Title.deviceEnDivice,
          content: this.Lang.Text.deviceEnDiviceCon,
          confirmButtonText: this.Lang.btn.enable,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        }).then(res => {
          this.changeDeviceStatus(flag);
        })
      } else {
        this.$dialog({
          title: this.Lang.Title.deviceDisDevice,
          // content: 'The device will <span style="color:red;"> stop reporting data and will not trigger any alerts until re-enabled</span> .Do you want to continue?',
          content: Lang.Text.deviceDisDeviceCon,
          confirmButtonText: this.Lang.Button.deviceDisable,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        }).then(res => {
          this.changeDeviceStatus(flag);
        })
      }
    },

    // 修改网关分组或网关状态
    changeGatewayOrGroupStatus(flag) {
      const params = {
        ids: this.currentNode.id,
        status: flag,
      };
      updateGatewayStatus(params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.updateSideTree();
          this.getGatewayOrGroupDetail(this.currentNode.id);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 修改设备状态
    changeDeviceStatus(flag) {
      const params = {
        ids: this.currentNode.id,
        status: flag,
      };
      updateDeviceStatus(params).then(res => {
        if (res.status === 200) {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.updateSideTree();
          this.getDeviceDetail(this.currentNode.id);
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleRefresh() {
      this.onLoad(this.page, this.search);
    },

    // 获取设备详情
    getDeviceDetail(id) {
      getDeviceDetailApi(id).then(res => {
        const data = res.data.data;
        this.currentNodeStatus = data.status;
        this.devicePageDetail = {
          ...data,
        };
        this.deviceForm = {
          ...data,
        }
      });
    },
    
    // 编辑设备
    handleEditDevice() {
      this.operationType = 'edit';
      getDeviceDetailApi(this.currentNode.id).then(res => {
        const data = res.data.data;
        this.deviceForm = {
          ...data,
        };
        this.deviceDialogBox = true;
      });
    },
    // 设备 提交
    handleSubmitDevice() {
      this.$refs.deviceFormRef.validate((flag) => {
        if (!flag) {
          return;
        }
        const params = filterDollarKeys(this.deviceForm);
        const submitBtnFn = this.operationType === 'edit' ? updateDeviceApi : addDeviceApi;
        submitBtnFn(params).then(
          () => {
            this.updateSideTree()
            this.handleRefresh()
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
            this.deviceDialogBox = false;
          },
          error => {
            window.console.log(error);
          }
        );
      })
    },

    handleTabChange(i, item) {
      const params = {
        stype: item.dictKey,
      };
      this.query.stype = params.stype;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
    },
    getNodeData(node) {
      console.log(node);
    },
    nodeClick({data, parentData}) {
      // this.treeData = treeData;
      this.parentData = parentData; // 保存用于查同步
      this.currentNode = data;
      if (data.gatewayType === 1) {
        // 网关分组
        this.getGatewayOrGroupDetail(data.id);
      } else if (data.gatewayType === 2) {
        // 网关
        this.getGatewayOrGroupDetail(data.id);
      } else {
        // 设备
        this.getDeviceDetail(data.id);
        this.onLoad(this.page, { rtuId: data.id });
      }
    },
    initData(tenantId) {
      this.getFourRemoteTypes();
      getDictionary({code: 'dataSourceType'}).then(res => {
        const data = res.data.data;
        this.dataSourceTypes = data;
      })
      this.updateSideTree()
      
    },
    updateSideTree(type) {
      const tenantId = this.userInfo.tenant_id;
      getTreeList(tenantId).then(res => {
        const data = res.data.data;
        this.treeData = data; // 组件自己点击
        this.$nextTick(() => {
          if (type == 'delete') {
            this.currentNode = data[0];
            this.handleClickFirstNode(data[0]);
          } else {
            this.handleClickFirstNode();
          }
        })
      });
    },
    handleClickFirstNode(nodeData) {
      const tree = this.$refs.treeRef;
      if (tree) {
        if (nodeData) {
          tree.updateCurrentNode(nodeData)
        }
        tree.autoClickFirstNode(nodeData)
      }
    },
    getFirstNode(data) {
      for (const node of data) {
        if (node.children && node.children.length > 0) {
          return this.getFirstNode(node.children); // 递归查找子节点
        }
        return node; // 返回第一个找到的节点
      }
      return null;
    },
    rowSave(row, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      add(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      row.deptId = func.join(row.deptId);
      row.roleId = func.join(row.roleId);
      row.postId = func.join(row.postId);
      update(row).then(
        () => {
          this.initFlag = false;
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    searchReset() {
      this.query = {};
      this.treeDeptId = '';
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      // this.$refs.crud.toggleSelection();
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
          if (this.form.hasOwnProperty('deptId')) {
            this.form.deptId = func.split(this.form.deptId);
          }
          if (this.form.hasOwnProperty('roleId')) {
            this.form.roleId = func.split(this.form.roleId);
          }
          if (this.form.hasOwnProperty('postId')) {
            this.form.postId = func.split(this.form.postId);
          }
        });
      }
      this.initFlag = true;
      done();
    },
    handlePageChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onLoad(this.page, this.query);
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.onLoad(this.page, this.query);
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    searchDevice() {
      this.page.pageSize = 10;
      this.page.currentPage = 1;
      this.onLoad(this.page, this.search)
    },
    onLoad(page, params = {}) {
      this.refreshIng = true;
      setTimeout(() => {
        this.refreshIng = false;
      }, 1000)
      // if (!this.treeData.length) {
      //   this.loading = false;
      //   return;
      // }
      const param = Object.assign(this.query, params);
      if (param.stype == 'All') {
        delete param.stype;
      }
      this.loading = true;
      getDevicePage(
        page.currentPage,
        page.pageSize,
        param
      ).then(res => {
        const data = res.data.data;
        this.lastUpdateTime = data.lastUpdateTime;
        this.page.total = data.pages.total;
        const records = data.pages.records || [];
        records.map(item => {
          item.isStorage = !!item.store;
        })
        this.tableData = records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
